import { refreshToken as refreshTokenApi } from 'App/api/loginApi';
import errorCodes from '../../util/errorCodes';
import { creators, selectors } from './tokenDuck';

export const refreshTokenAction = (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const refreshToken = selectors.refreshToken(getState());
    refreshTokenApi({ refreshToken })
      .then(token => {
        dispatch(creators.tokenRefreshSuccess(token.token, token.refreshToken, token.expires));
        resolve();
      })
      .catch(_e => {
        const error = new Error(errorCodes.app.REFRESH_TOKEN_ERROR);
        dispatch(creators.tokenRefreshFailed(error));
        reject();
      });
  });
